import { apiFactory } from '../ApiFactory';

type Phone = {
	countryCode: string;
	areaCode: string;
	number: string;
};

export type CreateCustomerDto = {
	name?: string;
	email?: string;
	isForeign: boolean;
	cpfCnpj?: string;
	phones: {
		mobilePhone?: Phone;
		homePhone?: Phone;
	};

	address?: {
		country: string;
		state: string;
		city: string;
		province: string;
		postalcode: string;
		address: string;
		number: string;
		complement: string;
	};

	authToken?: string;
};

const create = async ({ authToken, ...data }: CreateCustomerDto) =>
	(await apiFactory.getInstance().getCurseducaPayClient()).post(
		'/customers',
		data,
		{
			params: {
				token: authToken
			}
		}
	);

export const customersApi = {
	create
};
